import React from 'react';
import classNames from 'classnames';
import s from './style.scss';
const CardFA = ({ style, onClick, children }) => {
    return (React.createElement("div", { className: classNames(s.card, style), onClick: onClick }, children));
};
export default CardFA;
